import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorService } from '@app/services';
import { RolePermission } from '../../role-permission';

@Component({
	selector: 'hpf-role-permission-create',
	templateUrl: './role-permission-create.component.html',
})
export class RolePermissionCreateComponent implements OnInit {
	/** The role permission */
	rolePermission = new RolePermission();

	/** Constructor */
	constructor(private router: Router, private errorService: ErrorService) {}
	/** Init */
	ngOnInit() {}
	/** Called when the role permission is created */
	onCreate(rolePermission: RolePermission): void {
		this.router
			.navigateByUrl(`/role-permission/${rolePermission.getId()}`)
			.catch((error) => this.errorService.handle(error));
	}
}
